import { render, staticRenderFns } from "./page8Choice.vue?vue&type=template&id=0f7c6d34&scoped=true"
import script from "./page8Choice.vue?vue&type=script&lang=js"
export * from "./page8Choice.vue?vue&type=script&lang=js"
import style0 from "./page8Choice.vue?vue&type=style&index=0&id=0f7c6d34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7c6d34",
  null
  
)

export default component.exports